import React from "react";
import { styles } from "../styles/theme";

function LoadingPage() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>Cargando juego...</div>
    </div>
  );
}

export default LoadingPage;
